<script>
export default {
    name: "BankReceiptForm",

    props: {

        bankPayment: Object,
        errors: Array,
        totalBalance: Number,
        bankCOAs: Array,
        bankPModes: Array,
    },

    watch: {

        "bankPayment.paymentModeID"() {
            if(!this.bankPayment.paymentModeID) return;

            const matchPMs = this.bankPModes.filter(bankPMode => bankPMode.pmodeID == this.bankPayment.paymentModeID);

            this.bankPayment.paymentMode = matchPMs.length ? matchPMs[0].mode : ``;
        },

        "bankPayment.accountID"() {
            if(!this.bankPayment.accountID) return;

            const matchedAccounts = this.bankCOAs.filter(bankCOA => bankCOA.coaid == this.bankPayment.accountID);

            this.bankPayment.accountName = matchedAccounts.length ? matchedAccounts[0].coaName : ``;
        },

        totalBalance() {
            this.bankPayment.totalBankAmount = this.totalBalance;
        },
    },

    mounted() {

        this.bankPayment.totalBankAmount = this.totalBalance;
    },

}
</script>
<template>
<div class="flex flex-wrap">
    <div class="md:w-1/3 sm:w-full p-tiny">
        <label for="grid-account" class="label-control">Account:</label>
        <tail-select>
            <template v-slot:field>
                <select v-model="bankPayment.accountID" id="grid-account" class="input-control input-sm text-xs">
                    <option :value="0">select account</option>
                    <option v-for="(bankCOA, idx) in bankCOAs" :key="idx" :value="bankCOA.coaid">{{ bankCOA.coaName }}</option>
                </select>
            </template>
        </tail-select>
        <p class="form-text-error" v-if="errors.filter(error => error.field == 'accountID').length">
            {{ errors.filter(error => error.field == 'accountID')[0].message }}</p>
    </div>
    <div class="md:w-1/3 sm:w-full p-tiny">
        <label for="grid-p-mode" class="label-control">P.Mode:</label>
        <tail-select>
            <template v-slot:field>
                <select v-model="bankPayment.paymentModeID" id="grid-p-mode" class="input-control input-sm text-xs">
                    <option :value="0">select payment mode</option>
                    <option v-for="(bankPMode, idx) in bankPModes" :key="idx" :value="bankPMode.pmodeID">{{ bankPMode.mode }}</option>
                </select>
            </template>
        </tail-select>
        <p class="form-text-error" v-if="errors.filter(error => error.field == 'paymentModeID').length">
            {{ errors.filter(error => error.field == 'paymentModeID')[0].message }}</p>
    </div>
    <div class="md:w-1/3 sm:w-full p-tiny">
        <label for="grid-ref" class="label-control">Ref:</label>
        <input type="text" v-model.trim="bankPayment.bankRef" id="grid-ref" class="input-control input-sm text-xs">
        <p class="form-text-error" v-if="errors.filter(error => error.field == 'bankRef').length">
            {{ errors.filter(error => error.field == 'bankRef')[0].message }}</p>
    </div>
    <div class="md:w-1/3 sm:w-full p-tiny">
        <label for="grid-amount" class="label-control">Amt:</label>
        <input type="number" 
            v-model.number="bankPayment.totalBankAmount" min="0" disabled
            id="grid-amount" class="input-control input-sm text-xs text-right disabled">
        <p class="form-text-error" v-if="errors.filter(error => error.field == 'totalBankAmount').length">
            {{ errors.filter(error => error.field == 'totalBankAmount')[0].message }}</p>
    </div>
    <div class="md:w-1/3 sm:w-full p-tiny">
        <label for="grid-date" class="label-control">Date:</label>
        <input type="date" v-model="bankPayment.bankPayDate" id="grid-date" class="input-control input-sm text-xs">
        <p class="form-text-error" v-if="errors.filter(error => error.field == 'bankPayDate').length">
            {{ errors.filter(error => error.field == 'bankPayDate')[0].message }}</p>
    </div>
    <div class="md:w-1/2 sm:w-full p-tiny my-1">
        <label for="grid-is-post-dated" class="label-control whitespace-no-wrap">Is Post Dated <input type="checkbox" id="grid-is-post-dated"></label>
    </div>
    <div class="md:w-2/3 sm:w-full p-tiny">
        <label for="grid-memo" class="label-control">Memo:</label>
        <input type="text" v-model.trim="bankPayment.memo" id="grid-memo" class="input-control input-sm text-xs">
    </div>
</div>
</template>